import PublicBinahScanFlow from ".";

export default function PublicBinahScanFlowExamples() {
  return <PublicBinahScanFlow onCompletedFlow={() => {}} />;
}
